import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from './store';

/**
 * Gate around the entire authenticated app shell. Sends unauthenticated
 * visitors to /login and non-admins to /not-admin (where they can sign out
 * and try a different account). The admin-vs-not check trusts the cached
 * `isAdmin` flag — when `requireAdmin` on the backend rejects with 403, the
 * caller flips the user out and re-routes them.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const accessToken = useAuthStore((s) => s.accessToken);
  const location = useLocation();

  if (!accessToken || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!user.isAdmin) {
    return <Navigate to="/not-admin" replace />;
  }
  return <>{children}</>;
}
